import moment from 'moment';
import _get from 'lodash/get';
import _merge from 'lodash/merge';
import { getHistoryChartType, getHistoryEventType } from 'services/SensorHelper';
import { ConfigHelper, DataConverter } from 'services/charting';
import ConfigPresets from 'services/charting/presets';
import { EVENT_TYPE_MOTION } from 'constants/device';
import { AbstractChartController } from '../chart-abstract-base';

/* @ngInject */
export default class ChartMotionAggregatedController extends AbstractChartController {
    constructor(SensorEventsLoader, ToastService, $scope,EventEmitter) {
        super({
            SensorEventsLoader,
            ToastService,
            $rootScope: $scope.$root,
            EventEmitter,
        });
    }

    $onInit() {
        this.chartType = getHistoryChartType(this.thing);
        this.eventType = getHistoryEventType(this.thing);

        super.$onInit();
    }

    $onChanges(changes) {
        // If we have new chart extremes, update the x-axis
        if (changes.extremes && 
            changes.extremes.currentValue && 
            changes.extremes.currentValue !== changes.extremes.previousValue) 
        {
            this.xAxis.setExtremes(...changes.extremes.currentValue);
        }

        super.$onChanges(changes)
    }

    // Overrides AbstractChartController
    getEventTypes() {
        return [this.eventType];
    }

    // Overrides AbstractChartController
    getAggregationFields() {
        return [
            {"fieldName": "motion.state", "type": "DURATION"},
            // For offline detection
            {"fieldName": "networkStatus.signalStrength", "type": "COUNT"},
        ];
    }

    // Overrides AbstractChartController
    dataToLoad(days) {
        if (days < 7) {
            this.tooShortDuration = true;
            return "";
        } 
        
        this.tooShortDuration = false;
        return "aggregated";
    }
    
    // Overrides AbstractChartController
    aggregationBucketSizeSeconds(start, end) {
        const days = end.diff(start, 'days');
        
        // If the time range is less than 3 months, use daily buckets
        if (days < 31*3) {
            // TODO: Set y-axis label to "Daily motion"
            return 3600*24;
        }
        
        // Otherwise use weekly buckets
        // TODO: Set y-axis label to "Weekly motion"
        return 3600*24*7;
    }

    // Overrides AbstractChartController
    getConfigPreset() {
        return _merge(
            ConfigPresets.MotionAggregated,
            {
                chart: {
                    events: {
                        selection: this.handleChartSelection
                    }
                }
            }
        );
    }

    handleChartSelection({ xAxis }) {
        if (!xAxis || !xAxis.length) {
            return;
        }
        const { min, max } = xAxis[0];
        this.onChartSelection(
            this.EventEmitter({
                extremes: [min, max]
            })
        );
    }

    // Overrides AbstractChartController
    convertAggregated(aggregatedData) {
        if (aggregatedData.results.length === 0) {
            return {
                data: [],
                plotBands: [],
            }
        }
        this.chartData = aggregatedData.results[0].values.map(aggWindow => {
            return [
                moment(aggWindow.timeWindow).valueOf(),
                aggWindow.values["motion.state_DURATION"] / 3600,
            ]
        });

        this.plotBands = DataConverter.createAggregatedOfflineBands(
            aggregatedData.results[0].values,
            "networkStatus.signalStrength_COUNT",
        );
        
        return {
            data: this.chartData,
            plotBands: this.plotBands,
        }
    }

    // Overrides AbstractChartController
    convertToSeries(data, spacerStart, spacerEnd, spacerMin, spacerMax) {
        return ConfigHelper.proximitySeries(
            data,
            spacerStart,
            spacerEnd,
            spacerMin,
            spacerMax,
            {
                dataGrouping: {
                    units: [[
                        'week', // unit name
                        [1] // allowed multiples
                    ], [
                        'month',
                        [1]
                    ]]
                }
            }
        )
    }

    // Overrides AbstractChartController
    convertEvents(events) {
        const { state } = DataConverter.splitByStateAndNetworkStatus(events);
        this.sanitizeStateEvents(state);
        this.plotBands = [];
        this.chartData = state.map(({ data }) => [
            +new Date(data[EVENT_TYPE_MOTION].updateTime),
            1
        ]);
        return {
            data: this.chartData,
            plotBands: this.plotBands
        };
    }

    sanitizeStateEvents(stateEvents) {
        if (!stateEvents.length) {
            const state = _get(
                this.thing,
                'reported.motion.state',
                null
            );
            if (state) {
                const updateTime = moment(
                    _get(this.thing, 'reported.motion.updateTime')
                );
                stateEvents.push({
                    data: {
                        motion: {
                            state,
                            updateTime:
                                updateTime < this.chartMin
                                    ? this.chartMin
                                    : updateTime
                        }
                    }
                });
            }
        }
    }

    syncOfflinePlotBand() {}

    // Overrides AbstractChartController
    onStateEventReceived(eventData) { // eslint-disable-line no-unused-vars
        // TODO
    }
}
